import React from 'react';
import { Box, Chip, Slider, Stack, Typography } from '@mui/material';
import { getRhythmOption, RHYTHM_OPTIONS } from '../../utils/relationshipRhythm';

const marks = RHYTHM_OPTIONS.map(({ value, shortLabel }) => ({
  value,
  label: shortLabel,
}));

const RelationshipRhythmSlider = ({
  value = 30,
  onChange,
  disabled = false,
  label = 'Relationship rhythm',
}) => {
  const selected = getRhythmOption(value);

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        px: { xs: 2, sm: 2.5 },
        pt: 2,
        pb: { xs: 3.5, sm: 3 },
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        sx={{ mb: 1.5 }}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {label}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {selected.helper}
          </Typography>
        </Box>
        <Chip
          color="primary"
          variant="outlined"
          label={selected.label}
          sx={{ fontWeight: 700 }}
        />
      </Stack>
      <Slider
        value={selected.value}
        min={RHYTHM_OPTIONS[0].value}
        max={RHYTHM_OPTIONS[RHYTHM_OPTIONS.length - 1].value}
        marks={marks}
        step={null}
        disabled={disabled}
        onChange={(event, newValue) => onChange?.(Number(newValue))}
        valueLabelDisplay="off"
        sx={{
          mx: 0.5,
          width: 'calc(100% - 8px)',
          '& .MuiSlider-markLabel': {
            fontSize: { xs: '0.68rem', sm: '0.75rem' },
            whiteSpace: 'normal',
            maxWidth: 64,
            textAlign: 'center',
            lineHeight: 1.15,
          },
        }}
      />
    </Box>
  );
};

export default RelationshipRhythmSlider;
